import { gql } from '@apollo/client/core'

export const CHANGE_CURRENT_ADDRESS = gql`
  mutation currentAddressUpdate($addressId: ID!) {
    currentAddressUpdate(addressId: $addressId) {
      result {
        status
        message
      },
      token
    }
  }
`

export interface ChangeCurrentAddressVariables {
  addressId: number
}

export interface ChangeCurrentAddressResult {
  currentAddressUpdate: {
    result: {
      status: string,
      message: string
    },
    token: string
  }
}

export const SELECT_ALL_ADDRESSES = gql`
mutation selectAllAddresses {
  selectAllAddresses {
    result {
      status
      message
    },
    token
  }
}
`

export interface SelectAllAddressesResult {
  selectAllAddresses: {
    result: {
      status: string,
      message: string
    },
    token: string
  }
}
